import React from 'react';
import '../styles/components/Hero.css';

const Hero = () => {
  return (
    <section className="hero-redesign" id="home">
      {/* YouTube video embed as background */}
      <iframe
        className="hero-background-video"
        src="https://www.youtube.com/embed/8tzIJt5vw7s?autoplay=1&mute=1&loop=1&playlist=8tzIJt5vw7s&controls=0&showinfo=0&rel=0&modestbranding=1"
        title="Gyaniraj Offset Background Video New"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      />
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="hero-title">Gyaniraj Offset</h1>
        <p className="hero-tagline">A Complete Printing Solution</p>
        <div className="hero-animated-text">
          <span className="fade-in delay-1">Premium Quality Printing Solutions</span>
          <span className="fade-in delay-2">State-of-the-art technology with best quality and service</span>
        </div>
        <div className="hero-buttons">
          <a href="#services" className="btn btn-primary">Explore Services</a>
          <a href="#contact" className="btn btn-secondary">Get Free Quote</a>
        </div>
        <div className="hero-contact">
          <p>Contact: 9993143569 | Email: gyanirajoffset1@gmail.com</p>
          <p>Infront of Govt. B.ed College, near Chhatrasal Chowraha, District Hospital Shop No. 19, Chhatarpur (M.P.) 471001</p>
          <p>Work Time: 10:00 AM to 9:00 PM</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
